module.exports = __webpack_public_path__ + "static/media/spaceship.7a48973c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameProgramRobot/spaceship.png
// module id = 2451
// module chunks = 0